import React, {Component} from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from'react-slick';
let uniqid = require('uniqid');


class PortfolioContent extends Component {

	constructor(props) {
		super(props);

		this.state = {
			imagesData: props.data.gallery_images,
			videosData: props.data.gallery_videos,
			settings: "unslick"

		}
	}

	componentDidMount() {
		this.setState({
			settings: {
				dots: true,
				arrows: true,
				width: 640,
				height: 350
			}
		});
	}

	_getImages() {
		if (!this.state.imagesData) {
			return
		}

		return (
			(this.state.imagesData).map((item) => {
					return <div key={uniqid()}>
						<img src={item.sizes.thumb_16_9_800} alt={item.alt}/>
					</div>;
				}
			)
		);
	}

	_getVideos() {
		if (!this.state.videosData) {
			return
		}

		return (
			(this.state.videosData).map((item) => {
				return <div key={uniqid()}>
					<div className="embed-container">
						<iframe width='560' height='315'
						        src={"https://www.youtube.com/embed/" + item.photo_video_references}
						        frameBorder="0"
						        allowFullScreen
						        title={uniqid()}
						/>
					</div>
				</div>

			})
		);
	}


	render() {
		return (
			<div className="photo-portfolio">
				<Slider {...this.state.settings}>
					{/*<ul {...settings} data-slider-id={this.props.data.ID} className="slider-slick-cislo">*/}
					{this._getImages()}
					{this._getVideos()}
					{/*</ul>*/}
				</Slider>
			</div>
		)
	}
}

export default PortfolioContent;


// WEBPACK FOOTER //
// ./src/atoms/PortfolioContent.js